
import { PlanScope, GrantType } from '@/common/permission';

export default {
  props: {
    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      options: [{
        label: '可玩',
        value: PlanScope.Playable
      }, {
        label: '视频',
        value: PlanScope.Video
      }, {
        label: '可玩+视频',
        value: PlanScope.Playable_Video
      }]
    };
  },

  methods: {
    checkDisabled: function checkDisabled() {
      return this.action === 'update' || this.formValue.grant_type !== GrantType.Normal;
    }
  }
};